import React, {Component} from 'react';

import {DEFAULT_CENTER, DEFAULT_ZOOM, GOOGLE_MAPS_API_KEY, MAP_STYLE, ACTION_RED} from './constants';
import styles from './styles.module.scss';
import {DetailType} from '~screens/Dashboard/screens/ProjectsIIRSA/screens/ProjectDetail/types';
import {loadGeoJSON} from '~utils/geojson';

interface Props {
    project: DetailType
}

interface State {
    paths: string | null;
    markers: string | null;
    polygons: string | null;
}

// TODO i will need all the comented lines once the asstes are online
class Map extends Component<Props, State> {
    // its going to be needed once the project is online for the customizable icons
    // const markerIcon = window.location.host + MARKER_IMAGE[infrastructure]; // eslint-disable-line no-unused-vars
    //const zoom = getZoom(points);

    constructor(props) {
        super(props);
        this.state = {
            markers: null,
            paths: null,
            polygons: null
        }
        const gjsonPromise = loadGeoJSON(this.props.project.kmlSimplified);
        this.setPaths(gjsonPromise);
        this.setMarkers(gjsonPromise);
    }

    setPaths = (gjsonPromise) => {
        let paths = '';
        gjsonPromise.then(gjson => {
            gjson.features.forEach(f => {
                if (f.geometry.type == 'LineString') {
                    const currentPath = this.getCurrentPath(f.geometry.coordinates);
                    paths += `&path=color:${ACTION_RED}%7Cweight:5$%7C${currentPath}`;
                } else if (f.geometry.type == 'MultiLineString') {
                    f.geometry.coordinates.forEach(path => {
                        const currentPath = this.getCurrentPath(path);
                        paths += `&path=color:${ACTION_RED}%7Cweight:5$%7C${currentPath}`;
                    });
                } else if (f.geometry.hasOwnProperty('geometries')) {
                    f.geometry.geometries.forEach(g => {
                        if (g.type == 'LineString') {
                            const currentPath = this.getCurrentPath(g.coordinates);
                            paths += `&path=color:${ACTION_RED}%7Cweight:5$%7C${currentPath}`;
                        }
                    });
                }
            });
            this.setState({paths: paths});
        })
    };

    setMarkers = (gjsonPromise) => {
        let markers = '';
        gjsonPromise.then(gjson => {
            gjson.features.forEach(f => {
                if (f.geometry.type == 'Point') {
                    const coor = f.geometry.coordinates;
                    markers += `%7C${coor[1]},${coor[0]}`;
                } else if (f.geometry.hasOwnProperty('geometries')) {
                    f.geometry.geometries.forEach(g => {
                        if (g.type == 'Point') {
                            const coor = g.coordinates;
                            markers += `%7C${coor[1]},${coor[0]}`;
                        }
                    })
                }
            });
            this.setState({...this.state, markers: markers});
            this.setPolygons(gjsonPromise);
        });
    }

    setPolygons = (gjsonPromise) => {
        let polygons = '';
        gjsonPromise.then(gjson => {
            gjson.features.forEach(f => {
                if (f.geometry.type == 'Polygon') {
                    const currentPol = this.getCurrentPath(f.geometry.coordinates[0]);
                    polygons += `&path=color:${ACTION_RED}%7Cweight:5$%7Cfillcolor%3a${ACTION_RED}%7C${currentPol}`;
                } else if (f.geometry.hasOwnProperty('geometries')) {
                    f.geometry.geometries.forEach(g => {
                        if (g.type == 'Polygon') {
                            const currentPol = this.getCurrentPath(f.geometry.coordinates[0]);
                            polygons += `&path=color:${ACTION_RED}%7Cweight:5$%7Cfillcolor%3a${ACTION_RED}%7C${currentPol}`;
                        }
                    });
                }
            });
            this.setState({polygons: polygons});
        })
    }

    getCurrentPath = (coordinates) => {
        let currentPath = '';
        coordinates.forEach((c, index) => {
            if (index > 100) {
                return;
            }
            if (index > 0) {
                currentPath += '|';
            }
            currentPath += `${c[1]},${c[0]}`;

        });
        return currentPath;
    }

    render() {
        const {markers, paths, polygons} = this.state;

        let center = '';
        let zoom = '';
        if (this.props.project.staticCenter) {
            center = `center=${this.props.project.staticCenter.latitude},${this.props.project.staticCenter.longitude}&`;
            zoom = `zoom=${this.props.project.staticCenter.zoom}&`;
        } else if (!markers && !paths && !polygons) {
            // Nothing to fit the map to (geometry missing or unreadable): frame the region like the interactive map.
            center = `center=${DEFAULT_CENTER.lat},${DEFAULT_CENTER.lng}&`;
            zoom = `zoom=${DEFAULT_ZOOM}&`;
        }

        return (
            <img
                className={styles.map}
                src={`https://maps.googleapis.com/maps/api/staticmap?${center}${zoom}&markers=color:${ACTION_RED
                + (markers || '')}&size=316x316&${paths || ''}${polygons || ''}&${MAP_STYLE}&key=${GOOGLE_MAPS_API_KEY}`}
            />
        );
    }
}

export default Map;
